/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseWrapperGrantedOperationResponse } from '../../models/response-wrapper-granted-operation-response';

export interface GrantedOperation$Params {
}

export function grantedOperation(http: HttpClient, rootUrl: string, params?: GrantedOperation$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseWrapperGrantedOperationResponse>> {
  const rb = new RequestBuilder(rootUrl, grantedOperation.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseWrapperGrantedOperationResponse>;
    })
  );
}

grantedOperation.PATH = '/authorization/operations/granted';
